/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql, Script } from "gatsby"

function Seo({ description, title, children, noIndex }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteName
          }
        }
      }
    `
  )

  const metaDescription = description || ""

  return (
    <>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://www.defencath.com/defencath-logo.png" />
      <meta
        property="og:site_name"
        content={site.siteMetadata?.siteName || `DefenCath`}
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@DefenCath" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      {noIndex && <meta name="robots" content="noindex" />}
      {children}
      {/* <Script
        id="cookie-script-1"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        data-domain-script={process.env.GATSBY_COOKIE_TOKEN}
      /> */}
      <Script
        id="cookie-script-2"
        dangerouslySetInnerHTML={{ __html: `function OptanonWrapper() { }` }}
      />
    </>
  )
}

export default Seo
